import { GlobalService } from 'src/app/global.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { HttpService } from '../../http.service';
import { MatSort } from '@angular/material/sort';
import { ProductGroupService } from '../product-group.service';

@Component({
  selector: 'app-product-group-table',
  templateUrl: './product-group-table.component.html',
  styleUrls: ['./product-group-table.component.scss']
})
export class ProductGroupTableComponent implements OnInit {
  displayedColumns: string[] = ['id', 'name'];
  dataSource: any;
  monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  month_list_for_last_12_months: any = [];
  selected_month: any;

  constructor(private http: HttpService, public productGroupService: ProductGroupService, private global: GlobalService) {
    this.getProductGroup();
    this.productGroupService.downloadProductGroup.subscribe((is_update_zone) => {
      console.log(is_update_zone);
      if (is_update_zone) {
        this.getProductGroup();
      }
    });
    this.global.set_master_page_title = 'Product Group';

  }

  showProductGroupRegister() {
    this.productGroupService.is_display_product_group_register_component = true;
  }

  hideProuductGroupRegister() {
    this.productGroupService.is_display_product_group_register_component = false;
  }

  registerProductGroup() {
    this.showProductGroupRegister();
    console.log('register zone');
    this.productGroupService.productGroupUpdate.emit(null);
    this.productGroupService.set_product_group_data = null;
  }


  editProuductGroup(product_group) {
    this.showProductGroupRegister();
    console.log(product_group);
    this.productGroupService.productGroupUpdate.emit(product_group);
    this.productGroupService.set_product_group_data = product_group;
  }

  getProductGroup() {
    this.http.getProductGroup().subscribe((data: ProductGroup[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<ProductGroup>(data);
      this.dataSource.sort = this.sort;
    }, (error) => {
      console.log(error);
    });
  }

  ngOnInit() {
  }
}

export interface ProductGroup {
  id: number;
  name: string;
}
